module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2017_03.0d017fb0.jpg";